import { DASHBOARD_PATH } from 'scenes/Dashboard/Dashboard.routes'

export const SUBSPACES_PATH = `${DASHBOARD_PATH}/subspaces`
export const SUBSPACES_LIST_PATH = SUBSPACES_PATH
